/** @jsxImportSource @emotion/react */
import Header from '../components/header';
import Review from '../components/review';
import ReviewSelect from '../components/review-select';
import Slider from '../components/slider';

const S4Mobile = ({ selectReview, currentReviewIndex, reviews }) => (
  <div
    css={{
      flexDirection: 'column',
      alignItems: 'stretch',
      width: '100%',
    }}
  >
    <Header />

    <Slider currentReviewIndex={currentReviewIndex} reviews={reviews} selectReview={selectReview} />

    <Review currentReviewIndex={currentReviewIndex} reviews={reviews} css={{ marginBottom: 30 }} />
    <ReviewSelect
      currentReviewIndex={currentReviewIndex}
      selectReview={selectReview}
      reviews={reviews}
    />
  </div>
);

export default S4Mobile;
